// extracted by mini-css-extract-plugin
export default {"topStrip":"HeaderStrip_topStrip__H52kB","fraCode":"HeaderStrip_fraCode__sxRfo","fraName":"HeaderStrip_fraName__-n826"};